import {
  createLocale,
  enUS as naiveEnUs,
  dateEnUS,
  deDE,
  dateDeDE,
  plPL,
  datePlPL,
  trTR,
  dateTrTR,
  frFR,
  dateFrFR,
  esAR,
  dateEsAR,
  jaJP,
  dateJaJP,
  zhCN,
  dateZhCN,
  itIT,
  dateItIT,
  ptBR,
  datePtBR,
  nlNL,
  dateNlNL,
} from 'naive-ui'

import el from '@lib/custom-naive-locales/el'
import th from '@lib/custom-naive-locales/th'
import ptBrCustom from '@lib/custom-naive-locales/pt-br'
import type { SupportedLocale } from '@lib/types/i18n.types'

export const supportedLocales = [
  'en',
  'el',
  'fr',
  'es',
  'th',
  'ja',
  'zh',
  'it',
  'pt',
  'pt-br',
  'nl',
] as const as SupportedLocale[] // to add 'de', 'pl', 'tr',
export const fallbackLocale = 'en' as const satisfies SupportedLocale

const enUS = createLocale(
  {
    DatePicker: {
      confirm: 'CLOSE',
    },
  },
  naiveEnUs,
)
export const locales: Record<SupportedLocale, { locale: any; dateLocale: any }> = {
  en: { locale: enUS, dateLocale: dateEnUS },
  de: { locale: deDE, dateLocale: dateDeDE },
  pl: { locale: plPL, dateLocale: datePlPL },
  tr: { locale: trTR, dateLocale: dateTrTR },
  fr: { locale: frFR, dateLocale: dateFrFR },
  es: { locale: esAR, dateLocale: dateEsAR },
  ja: { locale: jaJP, dateLocale: dateJaJP },
  zh: { locale: zhCN, dateLocale: dateZhCN },
  it: { locale: itIT, dateLocale: dateItIT },
  pt: { locale: ptBR, dateLocale: datePtBR },
  'pt-br': { locale: createLocale(ptBrCustom, ptBR), dateLocale: datePtBR },
  nl: { locale: nlNL, dateLocale: dateNlNL },
  el: { locale: createLocale(el, naiveEnUs), dateLocale: dateEnUS },
  th: { locale: createLocale(th, naiveEnUs), dateLocale: dateEnUS },
}
export const localeNames: Record<SupportedLocale, string> = {
  en: 'English',
  de: 'Deutsch',
  pl: 'Polski',
  tr: 'Türkçe',
  el: 'Ελληνικά',
  fr: 'Français',
  es: 'Español',
  th: 'ไทย',
  ja: '日本語',
  zh: '中文',
  it: 'Italiano',
  pt: 'Português',
  'pt-br': 'Português (Brasil)',
  nl: 'Nederlands',
}
export const localeDropdownOptions = supportedLocales.map((locale) => ({ key: locale, name: localeNames[locale] }))
